// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kkTDA","footer":"styles_footer__2G18F"};